import i18n from '../../configuration/i18n';
import {push} from 'connected-react-router';
import * as actionTypes from '../actions/actionTypes';
import {put, select} from 'redux-saga/effects';
import _ from 'lodash';
import {INDEX_PAGE} from '../../configuration/paths';
import {currentLocation} from '../selectors/nav';
import {LoginModalId} from '../../services/constants';
import {showError} from '../../services/notifications';

export function sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
}

export function ValidationException(response) {
    this.response = {
        data: response,
        status: 400,
        statusText: 'Bad Request',
    };
}

function urlEqual(first, second) {
    return _.trimEnd(first, '/') === _.trimEnd(second, '/');
}

export function *handleError({error, silent = false, redirect = true, callbackActions = [], ignore = []}) {
    if (!error.response) {
        console.error(error);
        yield put({type: actionTypes.APP_ERROR, error});
        if (!silent) {
            yield showError(i18n.t('errors.appcrash'), i18n.t('errors.appcrashinfo'));
        }
    } else {
        const response = error.response;
        if (_.includes(ignore, response.status)) {
            return;
        }
        switch (true) {
            case _.includes([403, 401], response.status): {
                yield put({type: actionTypes.AUTH_ERROR, error});
                yield put({type: actionTypes.LOG_OUT});
                const requested_location = yield select(currentLocation);
                if (!silent && redirect && !urlEqual(requested_location, INDEX_PAGE)) {
                    yield put(push(INDEX_PAGE));
                    yield put({
                        type: actionTypes.OPEN_MODAL,
                        payload: {
                            id: LoginModalId,
                            message: {
                                type: 'error',
                                text: i18n.t('errors.logintocontinue'),
                            },
                            fallbacks: [push(requested_location), ...callbackActions],
                        },
                    });
                }

                break;
            }
            case response.status === 400: {
                yield put({type: actionTypes.BAD_REQUEST, error});
                if (!silent) {
                    yield showError(i18n.t('errors.badrequest'), i18n.t('errors.badrequestinfo'));
                }
                break;
            }
            case response.status === 404: {
                yield put({type: actionTypes.NOT_FOUND, error});
                if (!silent) {
                    yield showError(i18n.t('errors.notfound'), i18n.t('errors.notfoundinfo'));
                }
                break;
            }
            case _.inRange(response.status, 405, 500) || response.status === 402: {
                yield put({type: actionTypes.BAD_REQUEST, error});
                if (!silent) {
                    yield showError(i18n.t('errors.requestfailed'), i18n.t('errors.requestfailedinfo'));
                }
                break;
            }
            case response.status >= 500: {
                yield put({type: actionTypes.SERVER_ERROR, error});
                if (!silent) {
                    yield showError(i18n.t('errors.servererror'), i18n.t('errors.servererrorinfo'));
                }
                break;
            }
            default: {
                yield put({type: actionTypes.UNKNOWN_ERROR, error});
                if (!silent) {
                    yield showError(i18n.t('errors.unknownerror'), i18n.t('errors.unknownerrorinfo'));
                }
                break;
            }
        }
    }
}



// WEBPACK FOOTER //
// /src/redux/saga/common.js